'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _generateContentHash = require('./generateContentHash');

var _generateContentHash2 = _interopRequireDefault(_generateContentHash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * generates an unique reference hash
 *
 * @param {Object} style - style that get hashed
 * @return {string} hash - unique style hash
 */
exports.default = function (style) {
  return (0, _generateContentHash2.default)(JSON.stringify(style));
}; /*  weak */


module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ../~/fela/lib/utils/generateStyleHash.js
// module id = 436
// module chunks = 0